// Middlewares custom do store: listenerMiddleware (efeitos colaterais declarativos)
// + wsMiddleware (Socket.IO ↔ Redux actions). RTK Query api.middleware é adicionado
// no configureStore via getDefaultMiddleware().concat(...).
import { createListenerMiddleware, type TypedStartListening } from '@reduxjs/toolkit';
import { wsMiddleware } from '@/lib/ws/middleware';

export const listenerMiddleware = createListenerMiddleware();
export { wsMiddleware };

// Tipos pra usar startListening sem importar RootState/AppDispatch inline em cada
// arquivo. As features fazem: `listenerMiddleware.startListening as AppStartListening`.
// Não importamos RootState aqui pra evitar ciclo store ↔ middleware ↔ store.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppStartListening = TypedStartListening<any, any>;
